// نسخه — the screen's whole GraphQL contract, in one module.
//
// Three services do three jobs, and the split matters:
//
//   listDrugs             clinicalencounter — the seeded Iranian formulary. FREE.
//   checkDrugInteraction  aiassistant   — COSTS PARSINA CREDITS on every call.
//   createMedication      clinicalencounter — the persistence. FREE.
//
// `assistPrescription` is deliberately absent: it bills credits per call and
// phase 1 caps the AI surface at the interaction sweep.

import { C, CT } from '../../constants/theme';

export const LIST_DRUGS = `
  query ListDrugs($query: String, $limit: Int) {
    listDrugs(query: $query, limit: $limit) {
      id
      name
      genericName
      category
      commonDosages
      commonFrequencies
    }
  }
`;

export const CHECK_DRUG_INTERACTION = `
  query CheckDrugInteraction(
    $medicationIds: [String!]!
    $patientId: ID!
    $patientConditions: [String!]
    $patientAllergies: [String!]
  ) {
    checkDrugInteraction(
      medicationIds: $medicationIds
      patientId: $patientId
      patientConditions: $patientConditions
      patientAllergies: $patientAllergies
    ) {
      hasInteractions
      warnings { severity description drugPair source warningType drug condition }
    }
  }
`;

export const CREATE_MEDICATION = `
  mutation CreateMedication($patientId: ID!, $input: MedicationInput!) {
    createMedication(patientId: $patientId, input: $input) { id display }
  }
`;

// How long to sit on a change before spending a credit on the sweep. The doctor
// app uses the same 800 ms: short enough that the answer arrives while the
// dentist is still looking at the row, long enough that typing a dose does not
// bill four checks.
export const SWEEP_DEBOUNCE_MS = 800;

// The formulary search is free, so it can be far more eager than the sweep.
export const SEARCH_DEBOUNCE_MS = 300;
export const SEARCH_LIMIT = 30;

/**
 * The interaction warning's tint, by folded severity.
 *
 * Both surfaces paint the same three tones, from `CT` — a mobile card that
 * coloured «high» differently from the desktop rail would be two apps
 * disagreeing about how dangerous a pair of drugs is. Named here rather than in
 * either screen so neither can re-type it.
 *
 * Caller-side: `SEVERITY_TINT[severityKey(w.severity)]` — severityKey is total,
 * so the lookup can never miss.
 */
export const SEVERITY_TINT = {
  high: { bg: CT.dangerSoft, ink: CT.dangerInk },
  moderate: { bg: CT.warnSoft, ink: CT.warnInk },
  low: { bg: CT.surface2, ink: C.textSecondary },
};

/**
 * The ثبت button's label for the save phase machine.
 *
 * 'idle' → 'confirm' → 'saving'. A prescription is a clinical write; it takes
 * two deliberate taps, not one stray one, and both surfaces must ask twice.
 */
export function saveLabelKey(phase) {
  if (phase === 'saving') return 'prescription.saving';
  if (phase === 'confirm') return 'prescription.saveConfirm';
  return 'prescription.save';
}
